// src/authStrategies/OfhAuthStrategy.ts
import type { IntegrationInterface } from '@/interfaces/IntegrationInterface'
import axios from 'axios'
import { apiPostPublic } from '../util/api'
export class GeotabIntegration implements IntegrationInterface {
    async login(credentials: { email: string }): Promise<any> {
        // Assume `credentials` has { email: string, password: string }

        const user = credentials
        // You can customize it further based on `credentials` structure.
        const response = await apiPostPublic<{ data: any }>('auth/login', {
            user,
            integration_id: 'geotab'
        })

        return {
            token: response.headers['Authorization'] || response.headers['authorization'],
            data: response.data.data
        } // or manipulate and then return
    }
}

// Define other strategies similarly
